// Generated from: gulp/utils/boot.tpl.js
// Set webpack public path for async loading.
__webpack_public_path__ = window.baseUrl;

// Import main components.
import 'babel-core/external-helpers';
import './vendors/ConsoleDummy.min';
import Slideshow from './plugins/Slideshow/Slideshow';
import Site from './site';

// Load extra modules
new Slideshow();
new Site();



/** WEBPACK FOOTER **
 ** ./boot.js
 **/